import { render, staticRenderFns } from "./infra-module.vue?vue&type=template&id=2605f681&scoped=true&"
import script from "./infra-module.vue?vue&type=script&lang=js&"
export * from "./infra-module.vue?vue&type=script&lang=js&"
import style0 from "./infra-module.vue?vue&type=style&index=0&id=2605f681&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2605f681",
  null
  
)

export default component.exports